/**
 * Monitor the dom for image load errors, and replace with a 
 * data-default image or transparent gif data-uri.
 */
define('image-monitor/image-monitor',['require','exports','module'],function(require,exports,module){

	var alreadyListening = false,
        ERROR="data-load-error",
		DEF="data-load-default",
		monitor=function(e){
        	var source=e.target || e.srcElement,
        		nextSrc,
        		retry;

        	if(source && source.parentNode){

        		nextSrc=source.getAttribute(DEF),
        		retry=!source.getAttribute(ERROR);

        		if(retry){
        			if(nextSrc){
		        		source.removeAttribute(DEF);
		        		source.setAttribute(DEF+'-error',nextSrc);
		        	}
        			if(!nextSrc){
	        			source.setAttribute(ERROR,true);				        				
        			}
        			// source.src=null;
                    setTimeout(function(){
                        // Android 4.4.x requires a new handler to trigger a
                        // second fallback, and won't bubble to the window.
                        source.onerror=null;
                        source.onerror=function(){
                            this.onerror=null;
                            monitor({
                                target : this
                            });
                            return false;
                        }

    	        		source.src=nextSrc || defImg;
                    },4)
        		}
        	}
        	return false;
        },
        action = {
         "true" : "addEventListener",
         "false": "removeEventListener"
        },
        defImg="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==";

	return function(enable){
        if(!alreadyListening || enable!==true){
        	window[action[(!!enable).toString()]]('error',monitor,true,false);
            alreadyListening = enable===true;
        }
    };
});
